<template>
  <div>
    <section>
      <div class="uk-text-left uk-padding">
        <section class="section-titles">
          <h3 class="title">
            Seguros y Extrasxsss
          </h3>
        </section>
        <section>
          <div class="list-items">
            <div class="items">
              <label style="cursor: pointer">
                <input
                  v-model="insuranceExtrasImport.loadInsurance"
                  class="uk-checkbox"
                  type="checkbox"
                > Seguros al transporte marítimo en importacion
              </label>
            </div>

            <div class="items">
              <label style="cursor: pointer">
                <input
                  v-model="insuranceExtrasImport.transportInsurance"
                  class="uk-checkbox"
                  type="checkbox"
                > Penalizacion por carga no asegurada
              </label>
            </div>

            <div class="items">
              <label style="cursor: pointer">
                <input
                  v-model="insuranceExtrasImport.tradeAssociationFee"
                  class="uk-checkbox"
                  type="checkbox"
                >  Contratacion seguridad privada adicional (Para carga de alto valor)
              </label>
            </div>
          </div>
        </section>
      </div>
    </section>
    <div class="btn">
      <wizard-button />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      insuranceExtrasImport: {
        loadInsurance: null,
        transportInsurance: null,
        tradeAssociationFee: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'insuranceAndExtrasStore'
    ])
  },
  watch: {
    insuranceExtrasImport: {
      handler: function (newVal) {
        this.$store.commit('setInsuranceAndExtras', newVal)
      },
      deep: true
    }
  },
  mounted () {
    this.insuranceExtrasImport = { ...this.insuranceAndExtrasStore }
  }
}
</script>

<style scoped>
*{
  font-size: 12px;
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
section{
  padding: 10px;
}

.title{
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 16px;
}

.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}
.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}

.items{
  margin-bottom: 20px ;
}

@media screen and (max-width: 879px){

  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;

  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
  section{
    padding: 0px 10px 20px;
  }
}
</style>
